import React from "react";
import Customers from "../customers";
import LoginAsUser from "../../components/loginasuser/LoginAsUser";

const Customer = () => (
  <>
    <LoginAsUser />
    <Customers />
  </>
);

export default React.memo(Customer);
